export default __webpack_public_path__ + "static/media/mezcla.f0186f8f.jpg";